import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";
import * as DropdownTypes from "./DropdownTypes";

const nameFor = (menuItemId, profileMenu) =>
  profileMenu.children.find(c => c.id == menuItemId).name;

const DropdownItem = ({
  intl,
  type,
  to,
  profileMenu,
  onClick,
  enabled,
  messaging: {
    menu: { isMessagingEnabled = false },
    unreadMessageCount,
  },
  totalNotifications = 0 
}) => {
  if (!enabled) {
    return null;
  }

  return (
    <li>
      <Link to={to} onClick={onClick}>
        {intl.formatMessage({
          id: nameFor(type, profileMenu),
          defaultMessage: nameFor(type, profileMenu),
        })}
      </Link>
      {isMessagingEnabled &&
        type === DropdownTypes.MESSAGES && (
          <span className="apl-badge__message">
            {intl.formatMessage(messages.inAppMessages.unreadMessageBadge, {
              count: unreadMessageCount,
            })}
          </span>
        )}
        {type === DropdownTypes.PUSH_NOTIFICATIONS && (
          <span className={`notification-count-pp-dropdpwn  ${totalNotifications > 0 ? " with-background" : ""}`}>{totalNotifications}</span>
        )}
    </li>
  );
};

DropdownItem.propTypes = {
  intl: PropTypes.object,
  type: PropTypes.string,
  to: PropTypes.string,
  profileMenu: PropTypes.object,
  onClick: PropTypes.func,
  enabled: PropTypes.bool,
  messaging: PropTypes.object.isRequired,
  totalNotifications: PropTypes.number
};

export default injectIntl(DropdownItem);



// WEBPACK FOOTER //
// ./components/common/navigation/DropdownItem.js